import { render } from "./PositionBarWithBadge.vue?vue&type=template&id=30b61a5c&ts=true"
import script from "./PositionBarWithBadge.vue?vue&type=script&lang=ts"
export * from "./PositionBarWithBadge.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__